import { lastDayOfMonth } from 'date-fns';
import { FormatSegment } from '@app/app/_components/DatePicker/FormatSegment';

export function parseRawDigitsToDate(rawDigits: string, segments: FormatSegment[]): Nullable<Date> {
    let yearValue = 0;
    let monthValue = 0;
    let dayValue = 0;

    for (const seg of segments) {
        if (seg.kind === 'separator') continue;

        const chunk = rawDigits.slice(seg.digitOffset, seg.digitOffset + seg.length);

        if (seg.kind === 'year') yearValue = parseInt(chunk, 10);
        else if (seg.kind === 'month') monthValue = parseInt(chunk, 10);
        else if (seg.kind === 'day') dayValue = parseInt(chunk, 10);
    }

    if (monthValue < 1 || monthValue > 12) return null;

    const lastDay = lastDayOfMonth(new Date(yearValue, monthValue - 1, 1)).getDate();

    if (dayValue < 1 || dayValue > lastDay) return null;

    return new Date(yearValue, monthValue - 1, dayValue);
}
